import styled from 'styled-components';

export const TemplateContentInput = styled.textarea`
  resize: none;
  width: 100%;
  font-size: 16px;
  padding: 8px;
  border-radius: 12px;
`;
